import NotificationNewsCard from './NotificationNewsCard';

export default NotificationNewsCard;
